import Modal from '../../components/common/modal';
import meaganPhoto from '../../assets/images/meagan.png';

interface MeaganConfirmModalProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const MeaganConfirmModal: React.FC<MeaganConfirmModalProps> = ({ visible, onConfirm, onCancel }) => {
  if (!visible) {
    return null;
  }

  return (
    <Modal
      isModel={visible}
      InnerComponent={
        <div className="inline-block transform overflow-hidden bg-white align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md sm:align-middle">
          <div className="flex flex-col items-center px-6 py-8 text-center">
            <img
              src={meaganPhoto}
              alt="Meagan"
              className="border-blue-primary mb-4 h-40 w-40 rounded-full border-4 object-cover"
            />
            <h3 className="blue-primary mb-2 text-2xl font-normal">Are you Meagan?</h3>
            <p className="text-gray-dark mb-6 text-sm">
              Only Meagan may save external provider plan details. Everyone else must think long and hard about their
              life choices.
            </p>
            <div className="flex gap-3">
              <button
                type="button"
                className="bg-blue-primary h-10 rounded-sm px-6 text-sm text-white"
                onClick={onConfirm}
                data-testid="meagan-confirm-save-button"
              >
                Yes, I am Meagan
              </button>
              <button
                type="button"
                className="inline-flex h-10 items-center rounded-sm border bg-white px-6 text-sm text-gray-700 hover:bg-gray-50"
                onClick={onCancel}
                data-testid="meagan-cancel-save-button"
              >
                No, I am an impostor
              </button>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default MeaganConfirmModal;
